import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import devToolsPlugin from '@backstage/plugin-devtools/alpha';
import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';
import todoPlugin from '@backstage-community/plugin-todo/alpha';
import techRadarPlugin from '@backstage-community/plugin-tech-radar/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import adrPlugin from '@backstage-community/plugin-adr/alpha';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import scaffolderStudioPlugin from '@kissmiklosjr/plugin-scaffolder-studio/alpha';
// topology não filtra por annotation (sem isKubernetesAvailable no
// EntityContentBlueprint) — a aba "Topology" aparece em toda entity page,
// não só nas anotadas com backstage.io/kubernetes-id; nas demais só mostra
// o empty state ("no resources found"), não é bug.
import { topologyCatalogModule } from '@backstage-community/plugin-topology/alpha';
import entityValidationPlugin from '@backstage-community/plugin-entity-validation/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { themeModule } from './modules/theme';
import { homeModule } from './modules/home';
import { legacyEntityCardsModule } from './modules/legacyEntityCards';
import { persistentStorageModule } from './modules/persistentStorage';
import { s3ViewerModule } from './modules/s3Viewer';

export default createApp({
  features: [
    catalogPlugin,
    devToolsPlugin,
    announcementsPlugin,
    todoPlugin,
    techRadarPlugin,
    githubActionsPlugin,
    techdocsPlugin,
    adrPlugin,
    techInsightsPlugin,
    scaffolderStudioPlugin,
    topologyCatalogModule,
    entityValidationPlugin,
    navModule,
    authModule,
    themeModule,
    homeModule,
    legacyEntityCardsModule,
    persistentStorageModule,
    s3ViewerModule,
  ],
});
